var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms2A6B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 34,
    viewBox: "0 0 84 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 34,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.448 22.584V21.112H34.088V11.24H32.52V22.584H39.448Z",
    fill: "#252435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.454 20.52C40.454 21.736 41.462 22.824 43.03 22.824C44.406 22.824 45.174 22.088 45.51 21.544C45.51 22.104 45.558 22.392 45.59 22.584H47.062C47.03 22.392 46.966 21.992 46.966 21.32V17.464C46.966 15.96 46.07 14.648 43.766 14.648C42.102 14.648 40.774 15.672 40.614 17.144L42.054 17.48C42.15 16.584 42.742 15.928 43.798 15.928C44.966 15.928 45.462 16.552 45.462 17.304C45.462 17.576 45.334 17.816 44.87 17.88L42.79 18.184C41.462 18.376 40.454 19.144 40.454 20.52ZM43.238 21.56C42.47 21.56 41.99 21.016 41.99 20.44C41.99 19.752 42.47 19.384 43.11 19.288L45.462 18.936V19.288C45.462 20.968 44.47 21.56 43.238 21.56Z",
    fill: "#252435"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.829 22.584V21.464C51.309 22.296 52.189 22.792 53.325 22.792C55.613 22.792 56.909 20.984 56.909 18.696C56.909 16.456 55.709 14.664 53.373 14.664C52.093 14.664 51.197 15.288 50.829 15.976V11H49.341V22.584H50.829ZM55.373 18.696C55.373 20.36 54.477 21.448 53.101 21.448C51.773 21.448 50.813 20.36 50.813 18.696C50.813 17.032 51.773 15.992 53.101 15.992C54.493 15.992 55.373 17.032 55.373 18.696Z",
    fill: "#252435"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.929 17.944C59.993 16.952 60.761 15.976 62.025 15.976C63.385 15.976 64.105 16.84 64.137 17.944H59.929ZM64.361 19.944C64.073 20.808 63.449 21.496 62.201 21.496C60.905 21.496 59.913 20.536 59.881 19.16H65.673C65.689 19.064 65.705 18.872 65.705 18.68C65.705 16.28 64.377 14.648 62.009 14.648C60.073 14.648 58.329 16.296 58.329 18.712C58.329 21.32 60.137 22.824 62.201 22.824C63.993 22.824 65.225 21.752 65.657 20.392L64.361 19.944Z",
    fill: "#252435"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.095 22.584V11H67.591V22.584H69.095Z",
    fill: "#252435"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 18.7821,
    height: 18.7821,
    rx: 4,
    fill: "#4B31EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9557 14.387C20.2132 14.1214 20.3557 13.7656 20.3525 13.3963C20.3493 13.027 20.2006 12.6737 19.9384 12.4125C19.6763 12.1514 19.3217 12.0033 18.951 12.0001C18.5802 11.9968 18.2231 12.1388 17.9564 12.3954L13.3005 17.0336L11.4724 15.2124C11.2057 14.9558 10.8486 14.8138 10.4779 14.8171C10.1072 14.8203 9.75255 14.9684 9.49041 15.2295C9.22827 15.4907 9.07957 15.844 9.07635 16.2133C9.07313 16.5826 9.21564 16.9384 9.47319 17.204L12.3009 20.021C12.5661 20.2851 12.9256 20.4334 13.3005 20.4334C13.6755 20.4334 14.035 20.2851 14.3002 20.021L19.9557 14.387Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms2A6B);
export default __webpack_public_path__ + "static/media/forms2a6b.a0511772bc040570510cd03d8949ef84.svg";
export { ForwardRef as ReactComponent };